import { API } from 'aws-amplify';
import { AppSyncQuery } from '../../data/datatypes/graphql';

export const appSyncQueryPromise = async (query = new AppSyncQuery()) =>
  API.graphql(query);
